import React from "react";
import { withTranslation } from "react-i18next";


const VoucherHero = ({text}) => {

  return (
    <div className="voucher-activation__hero">
      <h1>{text[0]}</h1>
      <h1>{text[1]}</h1>
    </div>
  )
}

export default withTranslation()(VoucherHero);